import type { Activity } from "@/entities/activity";
import type { QueryKey } from "@tanstack/react-query";

import { getActivitySubjectModel } from "@/modules/activity";
import { getModelQueryKey } from "@/modules/model";

export const getActivityRestoreInvalidateKeys = (
  activity: Activity
): QueryKey[] => {
  // 1. Start with activity queries

  const queryKeys: QueryKey[] = [
    ["activities", "get", activity.id],
    ["activities", "list"],
  ];

  // 2. Then handle subject queries

  const modelKey = getActivitySubjectModel(activity);
  if (!modelKey) return queryKeys;

  const queryKey = getModelQueryKey(modelKey);
  queryKeys.push([queryKey, "list"]);

  const subjectId = activity.subject?.id;
  if (subjectId) queryKeys.push([queryKey, "get", Number(subjectId)]);

  // 3. Finally handle special cases

  // In intervention page, datasets are fetched using others queries
  if (modelKey === "dataset") {
    return [...queryKeys, ["interventions", "menu"], ["observations", "get"]];
  }

  return queryKeys;
};
